import React, { useState, useEffect } from "react";
import Membercard from "../Components/Membercard";
import Coreteam from "../Components/Coreteam";
import Navbar from "../Components/Navbar";
import { db } from "../firebase.config";
import { collection, getDocs } from "firebase/firestore";
import Footer from "../Components/Footer";

const Members = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const usersCollection = collection(db, "users");
        const userSnapshot = await getDocs(usersCollection);
        const userList = userSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setUsers(userList);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching users: ", error);
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const getCoreTeamMember = (role) => {
    const member = users.find((user) => user.role === role);
    return member ? (
      <Coreteam
        name={member.name}
        imageUrl={member.profileImageUrl || "https://via.placeholder.com/150"}
      />
    ) : null;
  };

  const getMembers = () => {
    return users
      .filter(
        (user) =>
          ![
            "chairperson",
            "secretary",
            "jointsecretary",
            "treasurer",
            "leaddesigner",
          ].includes(user.role)
      )
      .sort((a, b) => a.name.localeCompare(b.name)) // Sort members by name in ascending order
      .map((member) => (
        <Membercard
          key={member.id}
          name={member.name}
          club={member.club}
          image={member.profileImageUrl || "https://via.placeholder.com/150"}
        />
      ));
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-gray-900 to-black">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <>
      <div className="bg-gradient-to-br from-gray-900 to-black min-h-screen">
        <Navbar />
        <div className="container mx-auto p-4">
          <h1 className="font-bold mb-5 mt-5 text-white text-3xl text-center">
            CHAIRPERSON
          </h1>
          <div className="flex text-white justify-center mb-10">
            {getCoreTeamMember("chairperson")}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-10">
            <div>
              <h1 className="font-bold mb-5 mt-5 text-white text-3xl text-center">
                Secretary
              </h1>
              <div className="flex text-white justify-center">
                {getCoreTeamMember("secretary")}
              </div>
            </div>
            <div>
              <h1 className="font-bold mb-5 mt-5 text-white text-3xl text-center">
                Joint Secretary
              </h1>
              <div className="flex text-white justify-center">
                {getCoreTeamMember("jointsecretary")}
              </div>
            </div>
          </div>
          <div className="flex justify-center items-center gap-10 mb-10">
            <div>
              <h1 className="font-bold mb-5 mt-5 text-white text-3xl text-center">
                Treasurer
              </h1>
              <div className="flex text-white justify-center">
                {getCoreTeamMember("treasurer")}
              </div>
            </div>
          </div>
          <h1 className="font-bold text-white text-3xl text-center mt-10 mb-5">
            Our Members
          </h1>
          <div className="grid grid-cols-1 text-white sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 py-5 pb-20">
            {getMembers()}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Members;
